var issueSelectionForm = (function() {

    var $issueElements = $(".theme-group-toggle input[type=checkbox]");
    var $submitButtonElement, $selectAllButtonElement;

    function init($submitButton, $selectAllButton) {
        if (typeof $submitButton === 'object' && typeof $selectAllButton === 'object') {
          $submitButtonElement = $submitButton;
          $selectAllButtonElement = $selectAllButton;

            $issueElements.click(function() {
                setSubmitButtonState();
            });

            $selectAllButtonElement.click(function() {
                selectAllIssues();
                setSubmitButtonState();
            });

            setSubmitButtonState();
        }
    }

    function areIssuesSelected() {
        return $issueElements.is(":checked");
    }

    function setSubmitButtonState() {
        if (areIssuesSelected() === true) {
            $submitButtonElement.prop('disabled', false);
        } else {
            $submitButtonElement.prop('disabled', true);
        }
    }

    function selectAllIssues() {
        $issueElements.each(function() {
            var $inputElement = $(this);

            $inputElement.prop('checked', true);
            $inputElement.parent('label').addClass('active');
        });
    }

    return {
        init: init
    }
});
